export default "__VITE_ASSET__QK4tsXv4__"